import * as React from 'react';
import classNames from 'classnames';
import { AmountsOptions, Recipe, RecipeStep } from '@src/firebase/types';
import { ViewStepIngredient } from '@src/routes/recipes/components/ViewStepIngredient';

interface ViewStepProps {
  className?: string;
  recipe: Recipe;
  step: RecipeStep;
  stepIndex: number;
}

/**
 * @name ViewStep
 * @description tbd...
 */
const ViewStep: React.FC<ViewStepProps> = (props) => {
  const { className, recipe, step, stepIndex } = props;

  // Setup
  const { id, title } = step;
  const { ingredients } = recipe;
  const ingredientAndAmounts = ingredients.filter(
    (ingredient) => ingredient.stepId === id,
  );

  return (
    <div className={classNames(className, 'my-8')}>
      <div className="flex">
        <div className="flex-none w-6 font-medium text-xl text-indigo-600">
          {stepIndex + 1}.
        </div>
        <div className="text-gray-900 text-xl">{title}</div>
      </div>
      <div className="flex flex-row w-full">
        <div className="flex-none w-6"></div>
        <div className="grow mt-2 grid grid-cols-1 md:grid-cols-2 gap-0 basis-1/2">
          {ingredientAndAmounts.map((item, index) => (
            <ViewStepIngredient
              key={index}
              amount={AmountsOptions[item.amount]}
              ingredient={item.name}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export { ViewStep };
export type { ViewStepProps };
